import React, { useEffect, useContext } from "react";
import { useHistory } from "react-router-dom";
import * as Yup from "yup";
import Copyright from "../common_components/Copyright";
import { TextField } from "components/common_components/Formik";
import { useDispatch, useSelector } from "react-redux";
import { loginSuccess, loginError, logoutSuccess } from "../../redux/actions/Login";
import { Formik, Form } from "formik";
import Button from "../common_components/Button";
import Alert from "../common_components/Alert";
import { logout } from "config/firebaseWithFirestore";

import LoginContext from "../LoginRoute/LoginContext";
import { useCallback } from "react";
import Version from "components/common_components/Version";

const dayNames = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];

export default function Login(props) {
    const dispatch = useDispatch();

    const history = useHistory();

    const { Users, Login: LoginCT, BusinessHours } = useContext(LoginContext);

    const { loginError: lError, user } = useSelector((state) => state.Login);

    const hasSessionData = () => {
        return Boolean(localStorage.getItem("_t")) && Boolean(localStorage.getItem("_rt"));
    };

    const storeSessionData = async (data) => {
        const { token, refreshToken } = data;
        localStorage.setItem("_t", token);
        localStorage.setItem("_rt", refreshToken);
    };

    const clearSessionData = () => {
        localStorage.clear();
    };

    const doLogout = useCallback(() => {
        logout();
        dispatch(logoutSuccess());
    }, [dispatch]);

    const dispatchLoginError = useCallback(
        (message) => {
            dispatch(loginError(message));
            clearSessionData();
        },
        [dispatch]
    );

    useEffect(() => {
        if (user) {
            if (hasSessionData()) {
                history.push("/");
            } else {
                doLogout();
                dispatchLoginError("Your session has expired. Please sign in back!");
            }
        }
    }, [user, history, doLogout, dispatchLoginError]);

    function submitHandler({ email, password }, { setSubmitting }) {
        clearSessionData();
        setSubmitting(true);
        LoginCT.doLogin({
            email,
            password,
            onSuccess: async (response) => {
                await storeSessionData(response.data);
                const value = await Users.getOneByEmailAsync({ email });
                if (value && value.isActive) {
                    if (value.isAdmin) {
                        setSubmitting(false);
                        dispatch(loginSuccess(value));
                    } else {
                        if (value.hasRestrictedAccess) {
                            BusinessHours.getAll({
                                onSuccess: (data) => {
                                    const currentDate = new Date();
                                    const currentDay = dayNames[currentDate.getDay()];
                                    setSubmitting(false);
                                    if (data) {
                                        const businessHoursForDay = data.find((x) => x.dayOfWeek === currentDay);

                                        if (businessHoursForDay) {
                                            const { startTime, endTime } = businessHoursForDay;

                                            if (currentDate >= startTime && currentDate <= endTime) {
                                                dispatch(loginSuccess(value));
                                            } else {
                                                dispatchLoginError("You are not allowed to sign in at this time.");
                                            }
                                        } else {
                                            dispatchLoginError(
                                                "The user has restricted access, but no Business Hours were found for today."
                                            );
                                        }
                                    } else {
                                        dispatchLoginError("The user has restricted access, but no Business Hours were found.");
                                    }
                                },
                                onError: (error) => {
                                    setSubmitting(false);
                                    dispatchLoginError(`The user has restricted access, but no Business Hours were found. ${error}`);
                                },
                            });
                        } else {
                            setSubmitting(false);
                            dispatch(loginSuccess(value));
                        }
                    }
                } else {
                    setSubmitting(false);
                    dispatchLoginError("The user is not active or it doesn't exist.");
                }
            },
            onError: (error) => {
                setSubmitting(false);
                dispatchLoginError(error);
            },
        });
    }

    const validationSchema = Yup.object({
        email: Yup.string().required("Required field").email("Incorrect email"),
        password: Yup.string().required("Required field"),
    });

    return (
        <>
            <div className="login">
                <div className="login__form bg--secondary">
                    <div className="login__content">
                        <div className="login__logo" />
                        <div className="login__header">
                            <h1 className="text--white">Welcome</h1>
                            <Version />
                        </div>
                        <Formik onSubmit={submitHandler} initialValues={{ email: "", password: "" }} validationSchema={validationSchema}>
                            {({ isSubmitting }) => (
                                <Form>
                                    {lError && <Alert error>{lError}</Alert>}
                                    {/* TODO: These are fields defined for testing purposes regarding the input components refactor */}
                                    {/* <InputField fieldName="ssn" label="SSN" lowercase mask={Masks.ssn} />
                                    <InputField fieldName="charge" autoFocus label="Charge *" currency />
                                    <TextareaField fieldName="description" label="Description" rows={3} />
                                    <InputField fieldName="email" label="Email *" helperText="e.g myname@domain.com" autoComplete="email" /> */}
                                    <TextField
                                        fieldName="email"
                                        label="Email *"
                                        helperText="e.g myname@domain.com"
                                        autoComplete="email"
                                        className="form-item form-item--login form-item--dark"
                                    />
                                    <TextField
                                        type="password"
                                        fieldName="password"
                                        label="Password *"
                                        className="form-item form-item--login form-item--dark"
                                    />
                                    <Button primary type="submit" loading={isSubmitting}>
                                        Sign In
                                    </Button>
                                    <a className="link" onClick={() => history.push("/forgot-password")} href="#top">
                                        Forgot password?
                                    </a>
                                </Form>
                            )}
                        </Formik>

                        <Copyright />
                    </div>
                </div>
                <div className="login__image" />
            </div>
        </>
    );
}
